import logo from '@assets/logo.svg';

export const unitTypes = [
  'Bags',
  'Boxes',
  'Bundles',
  'Cases',
  'Crates',
  'Drums',
  'Items',
  'Pails',
  'Pallets',
  'Parts',
  'Pieces',
  'Skids',
  'Totes',
  'Units',
];

export const freightClasses = [
  '50',
  '55',
  '60',
  '65',
  '70',
  '77.5',
  '85',
  '92.5',
  '100',
  '110',
  '125',
  '150',
  '175',
  '200',
  '250',
  '300',
  '400',
  '500',
];

export const LTLWeightLimit = {
  Single: 3000,
  Total: 10000,
};

export const HAZMAT_ID = 'B419EE6D-312A-4E41-955C-7D761311D1A5';

export const atgLogo = `<img src=${logo} alt="" />`;
